import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentTagsSelectContentTemplate from "@Broker/@HandlebarsTemplates/clients/applications/documents/document-tags/_document-tags-select-content.hbs";
import { USER_DOCUMENT_LABELS, BROKERAGE_DOCUMENT_LABELS } from "@Broker/@Modules/clients/applications/documents/store/documents-getters";
import Select2 from "@Shared/components/inputs/select2";
import { mapGetters } from "vuex";
import InlineLoader from "@Shared/components/general/inline-loader";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentTagsSelect",
  components: {
    Select2,
    InlineLoader
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectDropdownParent: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    showUserLabels: {
      type: Boolean,
      default: true
    },
    selectedLabels: {
      type: Array,
      default: () => []
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("DocumentsStore", [USER_DOCUMENT_LABELS, BROKERAGE_DOCUMENT_LABELS])), {}, {
    options() {
      return {
        closeOnSelect: true,
        templateResult: this.formatResult,
        placeholder: this.$t("documents.selectLabel"),
        allowClear: false,
        dropdownCssClass: "tags-select form-group-material",
        matcher: this.matchCustom,
        disabled: this.disabled,
        dropdownParent: this.selectDropdownParent,
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    tags() {
      return this.showUserLabels ? this.USER_DOCUMENT_LABELS : this.BROKERAGE_DOCUMENT_LABELS;
    },
    selectedLabelsIds() {
      var _context;
      return _mapInstanceProperty(_context = this.selectedLabels).call(_context, label => label.id);
    }
  }),
  methods: {
    formatData(data) {
      const formattedData = data && _mapInstanceProperty(data).call(data, data => {
        var _data$shared;
        return {
          id: data.id,
          name: data.name,
          colour: data.colour,
          shared: (_data$shared = data.shared) != null ? _data$shared : false
        };
      });
      formattedData.unshift({
        id: "no-results-btn",
        name: ""
      });
      return formattedData;
    },
    matchCustom(params, data) {
      var _params$term, _data$name;
      const term = (_params$term = params == null ? void 0 : params.term) != null ? _params$term : "";
      const isTermEmpty = isEmpty(_trimInstanceProperty(term).call(term));
      const isNoResults = data.id === "no-results-btn";
      if (isTermEmpty) {
        return isNoResults ? null : data;
      }
      const name = (_data$name = data.name) != null ? _data$name : "";
      if (isNoResults) return _objectSpread(_objectSpread({}, data), {}, {
        name: term
      });
      if (_includesInstanceProperty(name).call(name, term)) return data;
      return null;
    },
    formatResult(tag) {
      const noResultsButton = tag.id === "no-results-btn";
      if (noResultsButton) {
        tag.text = $(".tags-select .select2-search__field").val();
      }
      return $(DocumentTagsSelectContentTemplate(_objectSpread(_objectSpread({}, tag), {}, {
        createNewText: this.$t("documents.createNewLabelWithThisName"),
        noResultsButton: noResultsButton,
        isSelected: this.isSelected(tag.id)
      })));
    },
    handleChange(label, action) {
      this.$emit("change", {
        label,
        action
      });
      this.$refs.select.setValue(this.value);
    },
    isSelected(id) {
      return this.selectedLabels.some(label => label.id === id);
    }
  }
});